import { makeApiRequest } from '@/src/lib/api-request'
import { useToken } from '@/src/store/token-store'
import { useUser } from '@/src/store/user-store'
import { useQuery } from '@tanstack/react-query'

interface AdvanceRecoveryAmount {
  usd_amount: number
  lyk_coins: number
}

export interface AdvanceRecoveryTimelineItem {
  id?: string | number
  date?: string
  date_label?: string
  issued_on?: string
  issued_on_label?: string
  recovered_amount: number
  recovered_to_date: number
}

export interface AdvanceRecoveryTimelineResponse {
  estimated_total_earnings: AdvanceRecoveryAmount
  net_estimated_earnings?: AdvanceRecoveryAmount
  breakdown: AdvanceRecoveryTimelineItem[]
  outstanding_amount: AdvanceRecoveryAmount
}

export const useAdvanceRecoveryTimelineQuery = (enabled = true) => {
  const { _hasHydrated } = useUser()
  const { accessToken } = useToken()

  return useQuery({
    queryKey: ['advance-recovery-timeline'],
    queryFn: async () => {
      try {
        const response = await makeApiRequest({
          method: 'GET',
          url: '/Earning/getAdvanceRecoveryTimeline',
          isAuthenticated: true,
          data: {},
          fallbackError: '',
          isV3Api: true,
        })

        return response.response as AdvanceRecoveryTimelineResponse
      } catch (error) {
        const message =
          error instanceof Error && error.message
            ? error.message
            : 'Error while fetching advance recovery timeline'

        throw new Error(message)
      }
    },
    enabled: enabled && !!_hasHydrated && !!accessToken,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
